import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DealEventRescheduleDto, type DealEventRescheduleInterface } from '@zaoblako/shared/modules/business/dto/deal-event/deal.event.reschedule.dto';
import { ChecklistPeriodFormComponent } from '@zaoblako/web/modules/project/dumbs/checklist-period-form/checklist-period-form.component';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'crm-deal-event-reschedule-form',
  standalone: true,
  imports: [CommonModule, JoinPipe, ButtonModule, EditorComponent, ChecklistPeriodFormComponent],
  templateUrl: './deal-event-reschedule-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DealEventRescheduleFormComponent extends BaseFormComponent<DealEventRescheduleInterface> {
  @Input() public dealEvent = <DealEventRescheduleInterface>{};
  public dto = DealEventRescheduleDto;
  public engine: 'class-transformer' | 'serde' = 'serde';
}
